// extracted by mini-css-extract-plugin
export default {"contentWrapper":"mobile_contentWrapper__BVW6T","appear":"mobile_appear__DOU3a","dashboardWrapper":"mobile_dashboardWrapper__yHGRH"};